import React from 'react';
/** ************* COMPONENTS  ******************** */
import BackButton from 'components/Button/BackButton';
import RefreshIcon from 'components/icons/RefreshIcon';
import { useParams } from 'react-router-dom/cjs/react-router-dom';

import ViewLenderPersonal from 'components/Views/ViewLenderPersonal';
/** ******************  APIES  ************************************* */
import { useGetCompanyUserDetailsQuery, useUpdateLenderMutation } from 'reducers/company.service';

// HELPER PROFESSIONALS
import RemoveMFA from 'components/MFA/RemoveMFA';
import ChangeAvatar from 'components/Avatar/ChangeAvatar';
import { Box, HStack } from '@chakra-ui/react';
// API CALLS
// import { viewMobile } from 'utils/number';
import 'assets/css/viewlayout.scss';
import 'assets/css/Preview.css';
import ChangeUserPassword from 'components/Action/ChangeUserPassword';
import ViewBranchData from 'components/Views/ViewBranchData';

const ViewCompanyUser = () => {
    let { id } = useParams();
    const { data , refetch, isLoading, isFetching } = useGetCompanyUserDetailsQuery(id);
    const mfaValue = data?.authData?.isTwoMfaEnable || false;
    const [updateLender] = useUpdateLenderMutation();
    const deleteAvatar = ()=>{
        updateLender({ id , body: { avatar: null } }).unwrap().then(()=>{
            refetch();
        });
    };

    return (
        <Box pt={{ base: '130px', md: '80px', xl: '65px' }}>
            <div style={{ display: 'flex', alignItems: 'center', gap: '8px', justifyContent: 'space-between' }}>
                <BackButton />
                <span>Back</span>
                <Box flex={1} textAlign={'end'}>
                    <RefreshIcon handleRefresh={ refetch}/>
                </Box>
            </div>

            <HStack
                width={'100%'}
                gap={'1rem'}
                mb="1rem"
                alignItems={'start'}
                mt={'1rem'}
            >

                <Box
                    flex={1}
                    p={4}
                    borderRadius="lg"
                    boxShadow="md"
                    border="1px solid #E2E8F0"
                    bg="white"
                >
                    <ViewLenderPersonal data={data} refetch={refetch}/>
                </Box>
                <Box
                    p="4"
                    h={'110vh'}
                    flex={1}
                    borderRadius="lg"
                    boxShadow="md"
                    border="1px solid #E2E8F0"
                    bg="white"
                >
                    <RemoveMFA
                        id={ id }
                        data={data}
                        mfaValue={mfaValue}
                        isFetching={ isFetching}
                        refetch={refetch}
                    />
                    <br />
                    <br />
                    <ChangeUserPassword data={data} refetch={refetch}/>
                </Box>
                <Box
                    p="4"
                    h={'110vh'}
                    flex={1}
                    borderRadius="lg"
                    boxShadow="md"
                    border="1px solid #E2E8F0"
                    bg="white"
                >
                    <ChangeAvatar
                        id={id}
                        data ={data}
                        refetch={refetch}
                        deleteAvatar={deleteAvatar}
                    />

                </Box>
            </HStack>
            <Box
                p="4"
                flex={1}
                borderRadius="lg"
                boxShadow="md"
                border="1px solid #E2E8F0"
                bg="white"
            >
                <div className="preview-heading space-between-box">
                    <p>
                                                    Branch Details
                    </p>

                </div>
                <ViewBranchData data={data?.branchId?.[0]} isLoading={isLoading}/>

            </Box>

        </Box>
    );
};

export default ViewCompanyUser;
